import LoaderState from './LoaderState';

const Loader = function () {
    this.state = new LoaderState();
    this.promise = null;
};

Loader.prototype.load = function () {
    let that = this;

    // Not yet loading
    if (!this.state.isLoading) {
        this.promise = new Promise(function (resolve) {
            let script, state;

            // Already loaded
            if (that.state.isLoaded) {
                resolve(that.state);
            }

            script = document.createElement('script');
            script.id = 'radiant-media-player';
            script.src = `radiant/dist/rmp.min.js`;

            script.onload = function () {
                let state;

                state = that.state.clone();
                state.isLoading = false;
                state.isLoaded = true;
                that.state = state;

                resolve();
            };

            script.onerror = function (error) {
                let state;

                state = that.state.clone();
                state.isLoading = false;
                state.isLoaded = false;
                state.error = new URIError(
                    `The script ${error.target.src} didn't load correctly.`,
                    {
                        cause: error,
                    }
                );
                that.state = state;

                resolve();
            };

            document.head.appendChild(script);

            state = that.state.clone();
            state.isLoading = true;
            that.state = state;
        });
    }

    return this.promise;
};

export default Loader;
